
import { DossierConfigService, IMollieProfile } from "@/services/dossier-config-service";
import Vue from "vue";
import AppCreateMollieProfile from "@/components/settings-default/MollieCreateProfile.vue";

export default Vue.extend({
	data(){
		return {
			ready: false,
			profiles: [] as IMollieProfile[],
			newProfileModal: false
		};
	},
	methods: {
		async authenticate(){
			try{
				let code = this.$route.query.code as string;
				await DossierConfigService.finishConnectWithMollie(code);
				this.profiles = await DossierConfigService.getMollieProfiles();
				this.ready = true;
			}catch(err){
				this.$router.push("/settings/bank");
			}
		},
		async setProfile(profile:IMollieProfile){
			let config = DossierConfigService.getMollieConfig();
			config.ProfileID = profile.ID;
			await DossierConfigService.saveMollieConfig(config);
			this.$router.push("/settings/bank");
		}
	},
	async mounted(){
		this.authenticate();
	},
	components: {
		AppCreateMollieProfile
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
